import {action, observable} from 'mobx'
import api from'../api';

class UpcomingTasksStore {
  @observable
  tasks = [];

  @observable
  isLoading = true;

  loadUpcomingTasks() {
    api.upcomingTasks().then(this.onLoadUpcomingTasks)
  }

  @action.bound
  onLoadUpcomingTasks(response){
    this.isLoading = false;
    this.tasks = response.data.tasks
  }
}

export default UpcomingTasksStore;
